import { createSelector } from "@reduxjs/toolkit";
import { GetMcbimSpacesApiResponse, openapi, PostMcbimItemsApiResponse } from "../../openapi";
import { IRootState } from "../app/store";
import { selectGetMcBimCeilingDevicesArgs, selectGetMcBimSpacesParams } from "./McBimSlice";

const EMPTY_SPACES: GetMcbimSpacesApiResponse = [];

export const selectHttpMcBimSpaceItems = (state: IRootState): GetMcbimSpacesApiResponse => {
  const args = selectGetMcBimSpacesParams(state);
  if (!args) return EMPTY_SPACES;
  return openapi.endpoints.getMcbimSpaces.select(args)(state).data ?? EMPTY_SPACES;
};

const EMPTY_ITEMS: PostMcbimItemsApiResponse = [];
export const selectHttpMcBimCeilingItems = (state: IRootState): PostMcbimItemsApiResponse => {
  const args = selectGetMcBimCeilingDevicesArgs(state);
  if (!args) return EMPTY_ITEMS;
  return openapi.endpoints.postMcbimItems.select(args)(state).data ?? EMPTY_ITEMS;
};

/** Hämtar query-resultatet (senaste i cachen) för nuvarande args */
export const selectHttpMcbimSpacesResult = (state: IRootState): GetMcbimSpacesApiResponse => {
  const args = selectGetMcBimSpacesParams(state);
  if (!args) return EMPTY_SPACES;
  return openapi.endpoints.getMcbimSpaces.select(args)(state).data ?? EMPTY_SPACES;
};
